import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MetaService } from '../../../services/meta.service';

@Component({
  selector: 'app-mot-du-de',
  templateUrl: './mot-du-de.component.html',
  styleUrls: ['./mot-du-de.component.scss']
})
export class MotDuDeComponent implements OnInit, AfterViewInit {

  constructor(private metaService: MetaService) { }

  ngOnInit(): void {
    // Mettre à jour les meta tags pour cette page
    this.metaService.updateDirectorMeta();
  }

  ngAfterViewInit(): void {
    this.observeElements();
    this.addHoverEffects();
  }

  /**
   * Observe les éléments pour les animations
   */
  observeElements(): void {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, { threshold: 0.1 });

    const elements = document.querySelectorAll('.vision-card, .timeline-item, .stat-item');
    elements.forEach(element => {
      observer.observe(element);
    });
  }

  /**
   * Ajoute des effets de hover sur les éléments interactifs
   */
  addHoverEffects(): void {
    const cards = document.querySelectorAll('.vision-card, .stat-item');
    cards.forEach(card => {
      card.addEventListener('mouseenter', () => {
        card.classList.add('hover-active');
      });
      
      card.addEventListener('mouseleave', () => {
        card.classList.remove('hover-active');
      });
    });
  }

  /**
   * Gère le clic sur la photo du directeur
   */
  onDirectorPhotoClick(): void {
    console.log('Photo du directeur cliquée');
    // Ici vous pouvez ajouter la logique pour ouvrir une modal avec une photo plus grande
  }

  /**
   * Gère le clic sur les cartes de vision
   */
  onVisionCardClick(visionTitle: string): void {
    console.log(`Vision ${visionTitle} cliquée`);
    // Ici vous pouvez ajouter la logique pour afficher plus de détails
  }

  /**
   * Gère le clic sur les éléments de la timeline
   */
  onTimelineItemClick(year: string, title: string): void {
    console.log(`Timeline item ${year} - ${title} cliqué`);
    // Ici vous pouvez ajouter la logique pour afficher plus de détails
  }

  /**
   * Gère le clic sur les statistiques
   */
  onStatClick(statLabel: string): void {
    console.log(`Stat ${statLabel} cliquée`);
    // Ici vous pouvez ajouter la logique pour afficher un graphique détaillé
  }

  /**
   * Gère le clic sur le bouton de contact
   */
  onContactClick(action: string): void {
    console.log(`Action de contact ${action} cliquée`);
    // Ici vous pouvez ajouter la logique pour rediriger vers la page de contact
  }

  /**
   * Gère le clic sur l'email du directeur
   */
  onEmailClick(): void {
    window.location.href = 'mailto:saifoulaye.balde@bstpgn.com';
  }

  /**
   * Méthodes de partage social
   */
  shareOnFacebook(): void {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent('Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée');
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${text}`, '_blank');
  }

  shareOnTwitter(): void {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent('Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée');
    window.open(`https://twitter.com/intent/tweet?url=${url}&text=${text}`, '_blank');
  }

  shareOnLinkedIn(): void {
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent('Mot du Directeur Exécutif | BSTP Guinée');
    const summary = encodeURIComponent('Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée');
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank');
  }

  shareOnWhatsApp(): void {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent('Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée');
    window.open(`https://wa.me/?text=${text}%20${url}`, '_blank');
  }

  shareByEmail(): void {
    const subject = encodeURIComponent('Mot du Directeur Exécutif - BSTP Guinée');
    const body = encodeURIComponent('Découvrez le message et la vision de Saifoulaye BALDE, Directeur Exécutif de la BSTP Guinée\n\n' + window.location.href);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  }

  copyLink(): void {
    navigator.clipboard.writeText(window.location.href).then(() => {
      // Afficher une notification de succès
      this.showNotification('Lien copié dans le presse-papiers !');
    }).catch(err => {
      console.error('Erreur lors de la copie du lien:', err);
      this.showNotification('Erreur lors de la copie du lien');
    });
  }

  /**
   * Affiche une notification
   */
  private showNotification(message: string): void {
    // Créer une notification simple
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #00533e;
      color: white;
      padding: 1rem 2rem;
      border-radius: 5px;
      z-index: 10000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    notification.textContent = message;
    document.body.appendChild(notification);

    // Supprimer la notification après 3 secondes
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 3000);
  }
}
